module.exports = __webpack_public_path__ + "img/top1.b4ef85e1.svg";